export default "__VITE_ASSET__CzL6QB43__"